import { Injectable } from '@angular/core';
import { MsgProps } from './highlighted-message.types';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HighlightedMessageService {
  public message: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);
  public icon: BehaviorSubject<string> = new BehaviorSubject('');

  constructor() {}
  /**
   * @returns void
   * @param msgProps: MsgProps
   * @memberof HighlightedMessageService
   */
  public displayMessage(msgProps: MsgProps): void {
    this.icon.next(msgProps.type);
    this.message.next(msgProps.message);
  }
  /**
   * @returns void
   * @memberof HighlightedMessageService
   */
  public removeMessage(): void {
    this.message.next(null);
  }
}
